const DeliveryCompany = {
  CJGLS: {
    value: 'CJGLS',
    label: 'CJ대한통운',
    url: `https://www.cjlogistics.com/ko/tool/parcel/tracking?gnbInvcNo=:trackingNumber`,
    shippingCode: 1,
  },
  KGB: {
    value: 'KGB',
    label: '로젠택배',
    url: `https://www.ilogen.com/m/personal/trace.pop/:trackingNumber`,
    shippingCode: 2,
  },
  EPOST: {
    value: 'EPOST',
    label: '우체국택배',
    url: `https://service.epost.go.kr/trace.RetrieveDomRigiTraceList.comm?displayHeader=N&sid1=:trackingNumber`,
    shippingCode: 3,
  },
  REGISTPOST: { value: 'REGISTPOST', label: '우편등기' },
  HANJIN: {
    value: 'HANJIN',
    label: '한진택배',
    url: `https://www.hanjin.com/kor/CMS/DeliveryMgr/WaybillResult.do?mCode=MN038&schLang=KR&wblnumText2=:trackingNumber`,
    shippingCode: 4,
  },
  HYUNDAI: {
    value: 'HYUNDAI',
    label: '롯데택배(구. 현대택배)',
    url: `https://www.lotteglogis.com/home/reservation/tracking/linkView?InvNo=:trackingNumber`,
    shippingCode: 5,
  },
  LOTTE: {
    value: 'LOTTE',
    label: '롯데택배',
    url: `https://www.lotteglogis.com/home/reservation/tracking/linkView?InvNo=:trackingNumber`,
    shippingCode: 6,
  },
  DAESIN: {
    value: 'DAESIN',
    label: '대신택배',
    url: `https://www.ds3211.co.kr/freight/internalFreightSearch.ht?billno=:trackingNumber`,
    shippingCode: 7,
  },
  ILYANG: {
    value: 'ILYANG',
    label: '일양로지스',
    url: 'http://www.ilyanglogis.com/functionality/tracking_result.asp?hawb_no=:trackingNumber',
    shippingCode: 8,
  },
  KDEXP: {
    value: 'KDEXP',
    label: '경동택배',
    url: `https://kdexp.com/service/delivery/etc/delivery.do?barcode=:trackingNumber`,
    shippingCode: 9,
  },
  HDEXP: {
    value: 'HDEXP',
    label: '합동택배',
    url: 'https://hdexp.co.kr/basic_delivery.hd?barcode=:trackingNumber',
    shippingCode: 10,
  },
  CHUNIL: {
    value: 'CHUNIL',
    label: '천일택배',
    url: 'http://www.chunil.co.kr/HTrace/HTrace.jsp?transNo=:trackingNumber',
    shippingCode: 11,
  },
  CVSNET: {
    value: 'CVSNET',
    label: 'GS 편의점택배',
    url: `https://www.cvsnet.co.kr/invoice/tracking.do?invoice_no=:trackingNumber`,
    shippingCode: 12,
  },
  CUPOST: {
    value: 'CUPOST',
    label: 'CU 편의점택배',
    url: `https://www.cupost.co.kr/postbox/delivery/localResult.cupost?invoice_no=:trackingNumber`,
    shippingCode: 13,
  },
  KUNYOUNG: {
    value: 'KUNYOUNG',
    label: '건영택배',
    url: 'https://www.kunyoung.com/goods/goods_01.php?mulno=:trackingNumber',
    shippingCode: 14,
  },
  HONAM: { value: 'HONAM', label: '호남택배', shippingCode: 15 },
  YONGMA: { value: 'YONGMA', label: '용마로지스', shippingCode: 16 },
  HILOGIS: { value: 'HILOGIS', label: 'HI택배', shippingCode: 17 },
  SLX: { value: 'SLX', label: 'SLX택배', shippingCode: 18 },
  HPL: {
    value: 'HPL',
    label: '한의사랑택배',
    url: 'http://www.hanips.com/html/sub03_03_1.html?logicnum=:trackingNumber',
    shippingCode: 19,
  },
  SEBANG: {
    value: 'SEBANG',
    label: '세방택배',
    url: 'https://delivery.sebang.com/sdelivery/guest/trace/trace.xhtml?DISPATCH_NOTE_NO=:trackingNumber',
    shippingCode: 20,
  },
  WONDERS: { value: 'WONDERS', label: '원더스퀵', shippingCode: 21 },
  NHLOGIS: { value: 'NHLOGIS', label: '농협택배', shippingCode: 22 },
  HOMEPICK: {
    value: 'HOMEPICK',
    label: '홈픽택배',
    url: 'https://www.homepick.com/tracking/:trackingNumber',
    shippingCode: 23,
  },

  HOMEINNOV: {
    value: 'HOMEINNOV',
    label: '홈이노베이션로지스',
    shippingCode: 1,
  },
  GNETWORK: { value: 'GNETWORK', label: '자이언트', shippingCode: 1 },
  WEVILL: { value: 'WEVILL', label: '우리동네택배', shippingCode: 1 },
  FOREVERPS: { value: 'FOREVERPS', label: '퍼레버택배', shippingCode: 1 },
  LSERVICE: { value: 'LSERVICE', label: '엘서비스', shippingCode: 1 },
  ZENIELSYSTEM: {
    value: 'ZENIELSYSTEM',
    label: '제니엘시스템',
    shippingCode: 1,
  },
  JLOGIST: { value: 'JLOGIST', label: '제이로지스트', shippingCode: 1 },
  HIVECITY: { value: 'HIVECITY', label: '하이브시티', shippingCode: 1 },
  HANSSEM: { value: 'HANSSEM', label: '한샘', shippingCode: 1 },
  LTL: { value: 'LTL', label: 'LTL', shippingCode: 1 },
  DADASMART: {
    value: 'DADASMART',
    label: '스마트로지스/다다스마트',
    shippingCode: 1,
  },
  LOGISPOT: { value: 'LOGISPOT', label: '로지스팟', shippingCode: 1 },
  FRESHMATES: { value: 'FRESHMATES', label: '프레시메이트', shippingCode: 1 },
  VROONG: { value: 'VROONG', label: '부릉', shippingCode: 1 },
  NKLS: { value: 'NKLS', label: 'NK로지솔루션', shippingCode: 1 },
  DODOFLEX: { value: 'DODOFLEX', label: '도도플렉스', shippingCode: 1 },
  ETOMARS: { value: 'ETOMARS', label: '이투마스', shippingCode: 1 },
  SHIPNERGY: { value: 'SHIPNERGY', label: '배송하기좋은날', shippingCode: 1 },
  VENDORPIA: { value: 'VENDORPIA', label: '에이스물류', shippingCode: 1 },
  COSHIP: { value: 'COSHIP', label: '캐나다쉬핑', shippingCode: 1 },
  GDAKOREA: { value: 'GDAKOREA', label: '지디에이코리아', shippingCode: 1 },
  BABABA: { value: 'BABABA', label: '바바바로지스', shippingCode: 1 },
  GOODSTOLUCK: {
    value: 'GOODSTOLUCK',
    label: '굿투럭',
    url: 'http://www.goodstoluck.co.kr/tracking/tracking_popup.php?invc_no=:trackingNumber',
    shippingCode: 1,
  },
  GENIEGO: { value: 'GENIEGO', label: '지니고', shippingCode: 1 },
  TODAYPICKUP: {
    value: 'TODAYPICKUP',
    label: '오늘의픽업',
    url: 'https://mall.todaypickup.com/front/delivery/list/:trackingNumber',
    shippingCode: 1,
  },
  NOGOK: { value: 'NOGOK', label: '노곡물류', shippingCode: 1 },
  SPASYS1: { value: 'SPASYS1', label: '스페이시스원', shippingCode: 1 },
  KOKUSAI: { value: 'KOKUSAI', label: '국제익스플레스', shippingCode: 1 },
  XINPATEK: { value: 'XINPATEK', label: '윈핸드해운상공', shippingCode: 1 },
  HEREWEGO: { value: 'HEREWEGO', label: '탱고앤고', shippingCode: 1 },
  FRESHSOLUTIONS: {
    value: 'FRESHSOLUTIONS',
    label: '프레시솔루션',
    shippingCode: 1,
  },
  WOONGJI: { value: 'WOONGJI', label: '웅지익스프레스', shippingCode: 1 },
  SBGLS: { value: 'SBGLS', label: 'sbgls', shippingCode: 1 },
  YUNDA: { value: 'YUNDA', label: 'yunda express', shippingCode: 1 },
  ALLTAKOREA: { value: 'ALLTAKOREA', label: '올타코리아', shippingCode: 1 },
  LOTTECHILSUNG: { value: 'LOTTECHILSUNG', label: '롯데칠성', shippingCode: 1 },
  VALEX: { value: 'VALEX', label: '발렉스', shippingCode: 1 },
  PINGPONG: { value: 'PINGPONG', label: '핑퐁', shippingCode: 1 },
  YDH: { value: 'YDH', label: 'YDH', shippingCode: 1 },
  CARGOPLEASE: { value: 'CARGOPLEASE', label: '화물을부탁해', shippingCode: 1 },
  GTSLOGIS: { value: 'GTSLOGIS', label: 'GTS로지스', shippingCode: 1 },
  EKDP: { value: 'EKDP', label: '삼다수가정배송', shippingCode: 1 },
  HOTSINCARGO: {
    value: 'HOTSINCARGO',
    label: '허싱카고코리아',
    shippingCode: 1,
  },
  SINOEX: { value: 'SINOEX', label: 'SINOTRANS EXPRESS', shippingCode: 1 },
  DRABBIT: { value: 'DRABBIT', label: '딜리래빗', shippingCode: 1 },
  HOMEPICKTODAY: {
    value: 'HOMEPICKTODAY',
    label: '홈픽오늘도착',
    shippingCode: 1,
  },
  DAERIM: { value: 'DAERIM', label: '대림통운', shippingCode: 1 },
  LOGISPARTNER: {
    value: 'LOGISPARTNER',
    label: '로지스파트너',
    shippingCode: 1,
  },
  TEAMFRESH: { value: 'TEAMFRESH', label: '팀프레시', shippingCode: 1 },
  CHAINLOGIS: { value: 'CHAINLOGIS', label: '두발히어로', shippingCode: 1 },
  GOBOX: { value: 'GOBOX', label: '고박스', shippingCode: 1 },
  FASTBOX: { value: 'FASTBOX', label: '패스트박스', shippingCode: 1 },
  PANSTAR: { value: 'PANSTAR', label: '팬스타국제특송', shippingCode: 1 },
  ACTCORE: { value: 'ACTCORE', label: '에이씨티앤코아물류', shippingCode: 1 },
  KJT: { value: 'KJT', label: '케이제이티', shippingCode: 1 },
  THEBAO: { value: 'THEBAO', label: '더바오', shippingCode: 1 },
  RUSH: {
    value: 'RUSH',
    label: '오늘회러쉬',
    url: 'https://rush.onul-hoi.com/order/tracking?trackingNumber=:trackingNumber',
    shippingCode: 1,
  },
  KT: { value: 'KT', label: 'kt express', shippingCode: 1 },
  IBP: { value: 'IBP', label: 'ibpcorp', shippingCode: 1 },
  HY: { value: 'HY', label: '한국야구르트', shippingCode: 1 },
  LOGISVALLEY: { value: 'LOGISVALLEY', label: '로지스밸리', shippingCode: 1 },
  TODAY: { value: 'TODAY', label: '투데이', shippingCode: 1 },
  ONEDAYLOGIS: {
    value: 'ONEDAYLOGIS',
    label: '라스트마일시스템즈',
    shippingCode: 1,
  },
  HKHOLDINGS: {
    value: 'HKHOLDINGS',
    label: '에이치케이홀딩스',
    shippingCode: 1,
  },
  JIKGUMOON: { value: 'JIKGUMOON', label: '직구문', shippingCode: 1 },
  CUBEFLOW: { value: 'CUBEFLOW', label: '큐브플로우', shippingCode: 1 },
  SHFLY: { value: 'SHFLY', label: '성훈물류', shippingCode: 1 },
  GBS: { value: 'GBS', label: '지비에스', shippingCode: 1 },
  BANPOOM: { value: 'BANPOOM', label: '반품구조대', shippingCode: 1 },
  GLOVIS: { value: 'GLOVIS', label: '현대글로비스', shippingCode: 1 },
  ARGO: { value: 'ARGO', label: '아르고', shippingCode: 1 },
  WINION: { value: 'WINION', label: '위니온로지스', shippingCode: 1 },
  JMNP: { value: 'JMNP', label: '중앙일보엠앤피', shippingCode: 1 },
};

export default DeliveryCompany;
